<script setup lang="ts">
import { DateTime } from "luxon";
import type { ArticleResource } from "@carnet/api/backoffice";

const props = defineProps<{
  article: ArticleResource;
}>();

const { t } = useI18n();

const tags = computed(() => (props.article.tags ?? []) as string[]);

function formatDate(dateStr: string): string {
  return DateTime.fromISO(dateStr).toFormat("dd MMMM yyyy");
}
</script>

<template>
  <article class="group/tile relative flex items-start justify-between gap-6 py-8 sm:pt-6 sm:pb-14">
    <div class="flex flex-col gap-y-3 sm:gap-y-6 min-w-0">
      <p class="text-2xl/snug sm:text-4xl group-has-hover/tile:underline decoration-1 underline-offset-[0.15em]">{{ article.title }}</p>
      <div class="flex flex-wrap gap-2">
        <UBadge v-if="article.publicationDate" color="primary">{{ formatDate(article.publicationDate) }}</UBadge>
        <UBadge v-for="tag in tags" :key="tag" color="primary" variant="outline">{{ tag }}</UBadge>
      </div>
    </div>

    <AppTileLink v-if="article?.link" :to="article.link" :aria-label="t('news.tile.link', { title: article.title })" external />
  </article>
</template>
